import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Modal, Button } from 'react-bootstrap';
import {
  STORAGE_MNG_LKFS_CHANNEL_SETS_SAVE_DATA,
  STORAGE_MNG_LKFS_INGEST_CONFIG_CHANNEL_SETS_SHOW_MODAL
} from '../../../actions';
import { StyledLkfsModal } from './LKFSModalNew';
import AudioChannelsStep from './AudioChannelsStep';
import ReportBugButton from '../../../../../components/ReportBugButton';
import Loader from '../../../../../components/Loader';

const onCloseModal = () => ({ type: STORAGE_MNG_LKFS_INGEST_CONFIG_CHANNEL_SETS_SHOW_MODAL, isShow: false });

const saveFileLkfsData = (file, data) => ({ type: STORAGE_MNG_LKFS_CHANNEL_SETS_SAVE_DATA, file, data })

class IngestFilesModal extends Component {

  onContinue = () => {
    this.props.onCloseModal();
  }

  onBack = () => {
    this.props.onSaveData();
    this.props.onCloseModal();
  }

  handleCloseModal = () => {
    this.props.onSaveData();
    this.props.onCloseModal();
  }

  renderContent() {
    const { filesLoading, files, filesError } = this.props;

    if (filesLoading) {
      return (
        <Modal.Body>
          <div style={{ textAlign: 'center', padding: '50px' }}>
            <Loader />
            <p>Build the file list for LKFS...</p>
          </div>
        </Modal.Body>
      );
    }

    if (filesError) {
      return (
        <>
          <Modal.Body>
            <div style={{ textAlign: 'center', padding: '50px', color: 'red' }}>
              <p>Error build the file list for LKFS: {filesError.message || 'Unknown error'}</p>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button bsStyle="default" onClick={this.onBack}>
              Back
            </Button>
          </Modal.Footer>
        </>
      );
    }

    const woMemfis = this.props.woMemfis;

    return (
      <AudioChannelsStep
        onCancel={this.handleCloseModal}
        onBack={this.onBack}
        onContinue={this.onContinue}
        files={files}
        WOMemfis={woMemfis}
      />
    );
  }

  render() {
    return (
      <StyledLkfsModal
        className={'wizard--modal'}
        dialogClassName={'lkfs-modal'}
        bsSize="large"
        backdrop="static"
        enforceFocus={false}
        show={true}
        onHide={this.handleCloseModal}
      >
        <Modal.Header>
          <Modal.Title>
            LKFS: Configure channel sets
            <ReportBugButton isForModal={true} />
          </Modal.Title>
        </Modal.Header>
        {this.renderContent()}
      </StyledLkfsModal>
    );
  }
}

export default connect(
  function mapState(state) {
    const { filesLoading, files, filesError } = state.storageManager.LKFSModalState;
    const { ingestWorkOrder, addFileToWoModalState } = state.storageManager;
    const selectedWoMemfis = ingestWorkOrder ? ingestWorkOrder.woMemfisId : addFileToWoModalState.currentWOMemfis;

    return {
      woMemfis: selectedWoMemfis,
      filesLoading,
      files,
      filesError
    };
  },
  function mapDispatch(dispatch) {
    return {
      onCloseModal: () => dispatch(onCloseModal()),
      onSaveData: (file, data) => dispatch(saveFileLkfsData(file, data))
    };
  }
)(IngestFilesModal);
